import React, { Component } from 'react';

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';
import { TextInput } from 'components/input';

import * as urls from './urls';
import { connect } from "react-redux";
import { SORT_ASC } from "reducers/resource/list/queryReducer";

export class MachineLendingFilter extends Component {

  render() {

    return (
      <FilterForm name="machine_lending_search" {...this.props}>
        <TextInput label="Owner Mobile" source="owner_mobile_number"/>
        <TextInput label="Shop ID" source="shop_id"/>
      </FilterForm>
    )
  }
}

const listActionOptions = {
  hasExport: true,
  exportFileName: "device_rental_data.csv",
  exportHeaders: [
    "ID", "Shop ID", "Owner Mobile", "Email",
    "Address", "District", "Province", "Serial Number",
    "Expiry Date", "Device Type", "Overdue Status",
  ],
  exportSources: [
    "id", "shop_id", "owner_mobile_number", "email",
    "address", "district", "region", "sn",
    "expiry_time", "device_type", "overdue_status",
  ]
};

class MachineLendingListBase extends Component {

  render() {

    return (
      <List
        hasCreate={true}
        {...listActionOptions}
        filters={<MachineLendingFilter/>}
        sort={{ field: 'shop_id', order: SORT_ASC}}
        {...this.props}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="shop_id" label="Shop ID"/>
          <TextField source="owner_mobile_number" label="Owner Mobile"/>
          <TextField source="email" label="Email"/>
          <TextField source="address" label="Address"/>
          <TextField source="district" label="District"/>
          <TextField source="region" label="Province"/>
          <TextField source="sn" label="Serial Number"/>
          <TextField source="expiry_time" label="Expiry Date"/>
          <TextField source="device_type" label="Device Type"/>
          <TextField source="overdue_status" label="Overdue Status"/>
          <EditButton linkTo={urls.machineLendingExtendFrontendPath} label="Extend"/>
        </Datagrid>
      </List>
    )
  }
}

const mapStateToProps = (state, props) => {

  return {
    id: decodeURIComponent(props.match.params.id),
    data: state.admin[props.resource].data[decodeURIComponent(props.match.params.id)],
    isLoading: state.admin.loading > 0,
  };
};

export const MachineLendingList = connect(
  mapStateToProps,
  {},
)(MachineLendingListBase);


// WEBPACK FOOTER //
// ./src/routes/product/MachineLendingList.js